// Traducciones del sorteo en español
const sorteo = {
    title: "Sorteo Zaquiel Comic - ¡Participa y Gana!",
    description: "Participa en el sorteo de Zaquiel Comic.",
    exclusiveRaffle: "¡Sorteo Exclusivo!",
    participateAndWin: "Participa en nuestra exposición y gana premios increíbles",
    howToParticipate: "¿Cómo participar?",
    step1: "Lee uno o más capítulos de <1>Zaquiel Comic</1>",
    step2: "Completa la encuesta con tu <1>correo universitario UEMC</1>",
    step3: "¡Cada capítulo valorado = <1>una participación extra</1>!",
    participateNow: "¡PARTICIPAR AHORA!",
    emailWarning: "Solo puedes participar con tu correo <1>@alumnos.uemc.es</1>. Puedes valorar cada capítulo una sola vez.",
    privacyNote: "Al participar, aceptas nuestra",
    privacyLink: "política de privacidad del sorteo",
    backToComic: "← Volver a Zaquiel Comic",
    successTitle: "¡Participación Registrada!",
    successMessage: "Tu opinión ha sido enviada. Ya estás participando en el sorteo.",
    successHint: "¿Has leído más capítulos? ¡Envía más valoraciones!",
    rateAnother: "Valorar otro capítulo",
    backToHome: "Volver al inicio"
};

export default sorteo;
